<template>
    <footer class="home-footer">
        <div class="home-footer-inner">
            <!-- 订阅 -->
            <div class="subs-email" v-if="isHome">
                <img v-lazy="require('../../../assets/images/email.png')" class="email-png" />
                <div>
                    <p class="subs-title">{{$t('travel_disc')}}</p>
                    <div class="input-outter">
                        <input
                            v-model.trim="email"
                            type="email"
                            class="input-inner"
                            placeholder="Enter your email"
                            readonly
                            @click.once="relieveInput"
                        />
                        <button class="subs-btn" @click="subscribleEmail">{{$t('subs_email')}}</button>
                    </div>
                </div>
            </div>

            <!-- 快速导航 -->
            <ul class="sortcut-nav">
                <li class="nav-item">
                    <h5 class="nav-item-title">{{$t("company")}}</h5>
                    <ul>
                        <li class="list-item list-item-link" @click="jump('/about')">{{$t('about')}}</li>
                        <li
                            class="list-item list-item-link"
                            @click="jump('/terms_of_conditions')"
                        >{{$t('terms_service')}}</li>
                        <li
                            class="list-item list-item-link"
                            @click="jump('/privacy_policy')"
                        >{{$t('privacy_policy')}}</li>
                    </ul>
                </li>
                <li class="nav-item">
                    <h5 class="nav-item-title">{{$t('order_support')}}</h5>
                    <ul>
                        <li class="list-item list-item-link" @click="jump('/allhelp')">{{$t('faq')}}</li>
                        <li
                            class="list-item list-item-link"
                            @click="jump('/contact')"
                        >{{$t('ct_us')}}</li>
                        <li
                            class="list-item list-item-link"
                            @click="jump('/contact')"
                        >{{$t('cor_contact')}}</li>
                    </ul>
                </li>
                <li class="nav-item" style="flex:3;">
                    <h5 class="nav-item-title">{{$t('pay_type')}}</h5>

                    <table class="table">
                        <tbody>
                            <tr>
                                <td>
                                    <img
                                        class="img-visa"
                                        v-lazy="require('../../../assets/payment/visa2.png')"
                                    />
                                </td>
                                <td>
                                    <img
                                        class="img-paypal"
                                        v-lazy="require('../../../assets/payment/paypal2.png')"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <img
                                        class="img-mastercard"
                                        v-lazy="require('../../../assets/payment/mastercard.png')"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <li class="nav-item">
                    <h5 class="nav-item-title">{{$t('follow_us')}}</h5>
                    <div>
                        <a
                            href="https://www.facebook.com/ebblyofficial/"
                            target="_blank"
                            class="icon icon-fb"
                        ></a>
                        <a
                            href="https://www.instagram.com/ebblyofficial/"
                            target="_blank"
                            class="icon icon-ins"
                        ></a>
                    </div>
                </li>
                <li class="nav-item">
                    <img class="download-img" v-lazy="require('../../../assets/download.png')" />
                    <p class="download-text">
                        {{$t('download')}}
                        <img
                            class="ebbly-logo"
                            v-lazy="require('../../../assets/images/ebbly_text.png')"
                        />
                    </p>
                </li>
            </ul>
        </div>

        <p class="home-footer-copyright">
            Copyright © 2019 ebbly Inc. All Right Reserved
            <a
                style="color: rgb(117, 185, 243);"
                href="http://www.miitbeian.gov.cn/"
                target="_blank"
            >{{copyRemark}}</a>
        </p>
    </footer>
</template>

<script>
import { validate, linkTo } from "@/lib/utils";

export default {
    data() {
        return {
            email: "",
            copyRemark: "" //是否显示备案链接
        };
    },
    computed: {
        //是否处于首页
        isHome() {
            return this.$route == null;
        }
    },
    created() {
        if (location.host.indexOf("ebbly.cn") !== -1) {
            this.copyRemark = "粤ICP备17158487号-3";
        }
    },
    methods: {
        /**
         * 解除订阅邮件输入框的输入
         */
        relieveInput(e) {
            e.target.removeAttribute("readonly");
        },

        /**
         * 跳转
         * @param {String} link 跳转链接
         */
        jump(link) {
            if (!this.$route) {
                /* 首页的情况 */
                linkTo(link);
                return;
            }

            this.$router.push(link);
        },

        /**
         * 订阅邮件
         */
        subscribleEmail() {
            if (!validate(this.email, "email")) {
                this.$msg.error(this.$t("email_error"));
                return;
            }

            this.$req
                .post("v1_8/notes_email", {
                    email: this.email
                })
                .then(({ data }) => {
                    if (data.code === "2000") {
                        //订阅成功！
                        this.$notify({
                            type: "success",
                            message: this.$t("thx_note"),
                            title: this.$t("subs_success")
                        });
                    } else {
                        this.$msg.error(data.msg);
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.home-footer {
    background-color: #fff;

    .home-footer-inner {
        width: 1140px;
        margin: 0 auto;

        .sortcut-nav {
            display: flex;
            align-items: flex-start;
            padding: 40px 0;

            .nav-item {
                flex: 2;

                .table {
                    width: 100%;

                    .img-visa {
                        width: 62px;
                    }

                    .img-paypal {
                        width: 98px;
                    }

                    .img-mastercard {
                        width: 57px;
                    }
                }

                .icon {
                    display: inline-block;
                    width: 32px;
                    height: 32px;
                    margin-right: 15px;
                }

                .icon-fb {
                    background: url("../../../assets/logo/home-sprite.png") -189px -10px;
                }

                .icon-ins {
                    background: url("../../../assets/logo/home-sprite.png") -241px -10px;
                }

                .download-img {
                    width: 77px;
                }

                .download-text {
                    font-size: 12px;
                    color: #484848;

                    .ebbly-logo {
                        vertical-align: text-bottom;
                        margin-left: 5px;
                    }
                }

                .nav-item-title {
                    margin: 0;
                    margin-bottom: 20px;
                }

                .list-item {
                    margin-bottom: 12px;
                    font-size: 14px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                .list-item-link {
                    color: #484848;
                    transition: color ease-in-out 0.3s;
                    cursor: pointer;

                    &:hover {
                        color: #00a9ba;
                    }
                }
            }
        }

        .subs-email {
            display: flex;
            padding: 38px 0;
            border-bottom: 1px solid #eee;

            .email-png {
                width: 64px;
                margin-right: 45px;
            }

            .input-outter {
                position: relative;
                box-sizing: border-box;
                border: 1px solid #c5c5c5;
                border-radius: 30px;
                height: 44px;
                width: 382px;

                .input-inner {
                    border: none;
                    border-radius: 30px;
                    height: 100%;
                    width: 100%;
                    box-sizing: border-box;
                    padding: 12px 22px;
                    padding-right: 123px;

                    &::placeholder {
                        color: #c5c5c5;
                    }
                }

                .subs-btn {
                    position: absolute;
                    right: -1px;
                    top: -1px;
                    width: 113px;
                    height: 44px;
                    border: none;
                    background: linear-gradient(
                        90deg,
                        #52d6ce 0%,
                        #00a9ba 100%
                    );
                    border-radius: 34px;
                    color: #fff;
                    font-size: 14px;
                    transition: opacity ease-in-out 0.3;
                    cursor: pointer;

                    &:hover {
                        opacity: 0.7;
                    }
                }
            }

            .subs-title {
                font-size: 16px;
                line-height: 20px;
                color: #000;
                margin-bottom: 12px;
            }
        }
    }

    .home-footer-copyright {
        line-height: 60px;
        font-size: 14px;
        text-align: center;
        background-color: #f2f2f2;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/Footer.vue